import { useCallback } from "react";
import { proxy, useSnapshot } from "valtio";
import { MenuIds, useMenus } from "./useMenus";

const transformModeState = proxy({
	isTransformMode: false,
	actions: {
		setIsTransformMode(value: boolean) {
			transformModeState.isTransformMode = value;
		},
	},
});

export function useIsTransformMode() {
	const {
		actions: { setMenu },
	} = useMenus();
	const { isTransformMode } = useSnapshot(transformModeState);

	const setIsTransformMode = useCallback(
		(enableTransform: boolean) => {
			transformModeState.actions.setIsTransformMode(enableTransform);

			// Open the Transform Panel when changing TO transform mode
			// Remark: Did not automatically closed the panel when closing transformMode,
			// because there is already logic to open the default menu when for example text zone is selected
			if (transformModeState.isTransformMode) {
				setMenu(MenuIds.PhotoTransform);
			}
		},
		[setMenu],
	);

	return [isTransformMode, setIsTransformMode] as const;
}
